import { ENV } from "../utils";

export class Comunicacion {
  baseApi = ENV.BASE_API;

  async getComunicaciones(accessToken, documentoId) {
    try {
      const url = `${this.baseApi}/comunicaciones/${documentoId}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async sendEmail(accessToken, data) {
    try {
      const url = `${this.baseApi}/comunicaciones/email`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200 && response.status !== 201) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async logComunicacion(accessToken, data) {
    try {
      const url = `${this.baseApi}/comunicaciones/log`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201 && response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
